module.exports = __webpack_public_path__ + "static/media/2XL.d1a4bd9d.jpg";